<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </div>

      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <label class="label-input">Section Name</label>
        <v-row>
          <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name"/></v-col>
          <v-col cols="12" md="4"><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor"/></v-col>
        </v-row>

        <div class="mt-4">
          <label class="label-input">Content</label>
          <div class="group-item">
            <v-row class="mb-2">
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.content.backgroundColor"
                  name="konfortify-banner-content-background"
                  label="Background"
                  default-color="#E2ECFD"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.content.textColor"
                  name="konfortify-banner-content-text"
                  label="Text color"
                  default-color="#000000"
                />
              </v-col>
            </v-row>
            <ckeditor :editor="editor" v-model="fields.content.html" :config="editorConfig" />
          </div>
        </div>

        <div class="mt-4">
          <label class="label-input">Image</label>
          <div class="group-item">
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.image.show" label="Show image" dense hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.image.showShapeCurved" label="Show shape curved" dense hide-details />
              </v-col>
            </v-row>
            <v-select
              v-model="fields.image.position"
              :items="imagePositionOptions"
              item-text="text"
              item-value="value"
              label="Position"
            />
            <UploadImage
              :image="{ imageSrc: fields.image.src }"
              :height="'240'"
              :typeUpload="'image'"
              @callback="handleUploadImage"
              @callbackDelete="handleRemoveImage"
            />
          </div>
        </div>

        <div class="mt-4"><ButtonPrimary :button="fields.button" /></div>

        <SectionSettingsContainerFuild
          class="mt-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :showBackgroundImage="false"
          :showContainerPage="false"
        />
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions>
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'KonfortifyBanner',
  components: { UploadImage, ButtonPrimary, ColorPicker, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      imagePositionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
      fields: {
        title: 'Konfortify bannner',
        enableAnchor: false,
        content: { html: '', backgroundColor: '#E2ECFD', textColor: '#000000' },
        image: { show: true, src: '', position: 'right', showShapeCurved: true },
        button: {
          show: false,
          backgroundColor: '#000000',
          color: '#FFFFFF',
          radius: 0,
          text: 'Shop now',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: { show: false, src: '' },
          subBtn: { show: false, text: '' },
        },
        settings: {
          paddingTop: false,
          paddingBottom: false,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: false,
          backgroundImageMobile: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value && value.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        content: { ...this.fields.content, ...(extract.content || {}) },
        image: { ...this.fields.image, ...(extract.image || {}) },
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleUploadImage(value) {
      this.fields.image.src = (value && value.imageSrc) || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionKonfortifyBanner(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 500;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.header-modal {
  top: 0;
}
.footer-modal {
  bottom: 0;
}
</style>
